export default function inBrowser(): boolean {
  return typeof window !== 'undefined';
}
